// Group a measure's NoteEvent[] into beats (chord-flagged notes stack into the previous beat).
// Ported from poc/web/app.js userBeats/rawToBeatIndex/beatIndexToRaw/beatIndexToRawIn.

import type { NoteEvent, BeatGroup } from "../../types/domain";

export function userBeats(raw: NoteEvent[]): BeatGroup[] {
  const groups: BeatGroup[] = [];
  raw.forEach((n, idx) => {
    if (n.chord && groups.length && !n.rest) groups[groups.length - 1].items.push({ n, idx });
    else groups.push({ dur: n.dur, rest: !!n.rest, items: [{ n, idx }] });
  });
  return groups;
}

export function rawToBeatIndex(raw: NoteEvent[], rawIdx: number): number {
  const g = userBeats(raw);
  for (let i = 0; i < g.length; i++) if (g[i].items.some((it) => it.idx === rawIdx)) return i;
  return -1;
}

export function beatIndexToRaw(raw: NoteEvent[], bi: number): number {
  const g = userBeats(raw);
  if (bi < 0 || bi >= g.length) return -1;
  return g[bi].items[0].idx;
}

// raw-note index for a clicked alphaTab beat within a measure's note array (-1 if empty)
export function beatIndexToRawIn(notes: NoteEvent[], beatInBar: number): number {
  const groups: number[][] = [];
  notes.forEach((n, idx) => {
    if (n.chord && groups.length && !n.rest) groups[groups.length - 1].push(idx);
    else groups.push([idx]);
  });
  return (beatInBar >= 0 && beatInBar < groups.length) ? groups[beatInBar][0] : -1;
}

// total quarter-beats occupied by a note list (grace notes count 0; a dotted beat is 1.5×, a triplet ⅔×)
export function beatsOf(raw: NoteEvent[]): number {
  let acc = 0;
  for (const g of userBeats(raw)) {
    const n = g.items[0] && g.items[0].n;
    if (n && n.grace) continue;
    acc += (4 / g.dur) * (n && n.dotted ? 1.5 : 1) * (n && n.triplet ? 2 / 3 : 1);
  }
  return acc;
}
